import type { InputHTMLAttributes } from 'react';

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'style'> {
  label?: string;
}

/** Текстовое поле в стиле Telegram (внутри Section). */
export function Input({ label, ...rest }: InputProps): JSX.Element {
  return (
    <label
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        padding: 'var(--space-md) var(--space-lg)',
        borderBottom: '0.5px solid var(--tg-separator)',
      }}
    >
      {label && (
        <span style={{ fontSize: 'var(--font-sm)', color: 'var(--tg-hint)' }}>{label}</span>
      )}
      <input
        {...rest}
        style={{
          background: 'transparent',
          border: 'none',
          outline: 'none',
          padding: 0,
          fontSize: 'var(--font-md)',
          color: 'var(--tg-text)',
          minHeight: 24,
        }}
      />
    </label>
  );
}
